import { DUCK_CHAT_V1_ROUTE } from "duck/constants";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useConfigContext } from "shared/contexts/ConfigContext";

import { VIADUCK_PAGE_CONFIG_KEY } from "pages/SuperAdmin/PagesConfig/types";

export const useViaduckEnabled = () => {
  const { pages } = useConfigContext();

  return Boolean(pages[VIADUCK_PAGE_CONFIG_KEY]);
};

export const useDuckChatRoute = (): string => {
  const { duckChatRoute } = useFlags();

  return duckChatRoute || DUCK_CHAT_V1_ROUTE;
};
